export default "__VITE_ASSET__ThmTs5Qc__"